import './style.scss';

import { DocumentUnion } from "shared/types/types";
import React, { FC } from 'react';
import { ReactComponent as Lock } from "../../assets/img/icons/icon_Lock.svg";
import NationalityBadge from '../NationalityBadge';
import ToggleIdNumber from '../ToggleIdNumber';
import { formatTypeDocument } from '../../assets/functions/'
import { useNavigate } from 'react-router-dom';
import { parseFormatDateIDProtect } from "shared/lib/date_utils";
import { joursRestants } from "../../utils/utils";
import { ReactComponent as IconCLockSmall } from "../../assets/img/icons/icon_clock_small.svg";


type DocumentCardProps = {
  document: DocumentUnion;
  hideTypeDoc?: boolean;
  showRemainDateExp?: boolean;
};
const DocumentCard: FC<DocumentCardProps> = ({ document, hideTypeDoc = false, showRemainDateExp = false }) => {
  const navigate = useNavigate();
  const handleDocumentClick = (id: number) => {
    navigate(`/mes-documents/${id.toString()}`);
  };
  return (
    <div className="DocumentCard" onClick={() => handleDocumentClick(document.id)}>
      <div className='DocumentCard__header'>
        <div className='d-flex gap-1'>
          {!hideTypeDoc && (
            <p className="DocumentCard__type">{formatTypeDocument(document.type)}</p>
          )}
          <NationalityBadge />
        </div>
        <div className='d-flex gap-1 align-items-center'>
          <span className={`tag ${document.status === 'SUIVI' ? 'tag-success' : 'tag-error'}`}>
            {document.status}
          </span>
          {document.isBlocked ? <Lock fill="#9FC1EF" width={16} height={16} /> : <span style={{ width: '16px', height: '16px' }}></span>}
        </div>
      </div>
      <div className="d-flex flex-wrap-reverse w-100 flex-row justify-content-between align-items-center gap-1">
        {/*<p className={"text-dark text-xs text-ellipsis w-32"}>{`${document?.prenom ?? ""} ${document?.nom ?? ""}`}</p>*/}
        <div className={"pr-4"}><ToggleIdNumber number={document.number} /></div>
      </div>
      {showRemainDateExp ? (
        <>
          <span
            className={`bg-error-70 text-error-40 rounded-lg text-center gap-05 d-flex flex-wrap justify-content-center align-items-center py-2 px-3`}
          >
             <span>
                 <IconCLockSmall width={8} />
             </span>
            <span className={"text-sm"}>{`${joursRestants(document?.dateExpiration)?.message ?? ''}`}</span>
          </span>
        </>
      ) : (
        <>
          <p className="DocumentCard__date"><span
            className="DocumentCard__date__label">Date d'expiration : </span>{parseFormatDateIDProtect(document?.dateExpiration)}
          </p>
        </>
      )}
    </div>
  );
}

export default DocumentCard;
